import React from "react";
import { Card, Text, Icon, Box, Badge, Grid } from "~/components-shared";
import styled from "styled-components";
import Doughnut from "~/components-shared/Doughnut";
import lists from "~/lib/lists";
import { helpers } from "~/lib/helpers";
import { genericColor } from "~/lib/resolvers";
import { useTranslation } from "react-i18next";
const List = styled.ul`
  color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.text.secondary;
}};
  list-style: none;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  font-size: 12px;
`;
const Color = styled.i`
  background-color: ${_ref2 => {
  let {
    $color,
    theme
  } = _ref2;
  return genericColor(theme, $color);
}};
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
`;
const ContributionsCard = _ref3 => {
  let {
    size,
    dateFrom,
    dateTo,
    widget,
    ...rest
  } = _ref3;
  const {
    t
  } = useTranslation();
  const {
    current,
    previous
  } = widget.data;
  const currentSum = Object.values(current.byType).reduce((p, c) => p + c, 0);
  const previousSum = Object.values(previous.byType).reduce((p, c) => p + c, 0);
  const deltaPercentage = previous.total === 0 ? 0 : (current.total - previous.total) / previous.total * 100;
  const currentMapped = Object.keys(current.byType).map(type => ({
    name: lists.insights.workTypes.names[type],
    color: lists.insights.workTypes.colors[type],
    percent: current.byType[type] / currentSum * 100,
    value: current.byType[type]
  }));
  const previousMapped = Object.keys(previous.byType).map(type => ({
    name: lists.insights.workTypes.names[type],
    color: lists.insights.workTypes.colors[type],
    percent: previous.byType[type] / previousSum * 100,
    value: previous.byType[type]
  }));
  const types = [...Object.keys(current.byType), ...Object.keys(previous.byType)].filter(helpers.onlyUnique);
  const [currPeriod, prevPeriod] = helpers.humanReadablePeriodDiff(dateFrom, dateTo);
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8,
    s: {
      mb: 1
    }
  }, t("TrendCategoriesCard.trendsByCategory")), /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    template: "auto auto",
    align: "center",
    justify: "center",
    gap: 5,
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement(Doughnut, {
    size: 55,
    contents: /*#__PURE__*/React.createElement(Box, {
      align: "center",
      direction: "column"
    }, /*#__PURE__*/React.createElement(Text, {
      fontSize: 9,
      lineHeight: 9,
      weight: "bold",
      color: "text",
      display: "block"
    }, current.total), /*#__PURE__*/React.createElement(Text, {
      fontSize: 3.5,
      color: "textSecondary",
      align: "center",
      s: {
        mb: 1
      }
    }, currPeriod), /*#__PURE__*/React.createElement(Badge, {
      fontSize: 3.5,
      weight: "semiBold",
      color: deltaPercentage > 0 ? "translucentSuccess" : "translucentDanger"
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "chevron",
      rotate: deltaPercentage > 0 ? 0 : 180
    }), Math.abs(deltaPercentage).toFixed(0), "%"))
  }, /*#__PURE__*/React.createElement(Doughnut.Arc, {
    width: 5,
    values: currentMapped.map(_ref4 => {
      let {
        percent
      } = _ref4;
      return percent;
    }),
    colors: currentMapped.map(_ref5 => {
      let {
        color
      } = _ref5;
      return color;
    }),
    labels: currentMapped.map(_ref6 => {
      let {
        value,
        name
      } = _ref6;
      return `${value} ${name} (${currPeriod})`;
    })
  }), /*#__PURE__*/React.createElement(Doughnut.Arc, {
    opacity: 0.4,
    scale: 0.83,
    width: 5,
    values: previousMapped.map(_ref7 => {
      let {
        percent
      } = _ref7;
      return percent;
    }),
    colors: previousMapped.map(_ref8 => {
      let {
        color
      } = _ref8;
      return color;
    }),
    labels: previousMapped.map(_ref9 => {
      let {
        value,
        name
      } = _ref9;
      return `${value} ${name} (${prevPeriod})`;
    })
  })), /*#__PURE__*/React.createElement(List, null, types.map(type => {
    const prevTotal = previous.byType[type] || 0;
    const currTotal = current.byType[type] || 0;
    const itemDelta = prevTotal === 0 ? 0 : (currTotal - prevTotal) / prevTotal * 100;
    return /*#__PURE__*/React.createElement("li", {
      key: type
    }, /*#__PURE__*/React.createElement(Grid, {
      cols: 3,
      template: "12px 1fr auto",
      gap: 2,
      align: "center"
    }, /*#__PURE__*/React.createElement(Color, {
      $color: lists.insights.workTypes.colors[type]
    }), /*#__PURE__*/React.createElement(Text, {
      fontSize: 3.5,
      s: {
        mr: 2
      }
    }, lists.insights.workTypes.names[type]), itemDelta !== 0 && /*#__PURE__*/React.createElement(Badge, {
      fontSize: 3,
      s: {
        py: 0.5,
        pl: itemDelta === 0 ? 2 : 1
      },
      weight: "semiBold",
      color: prevTotal === 0 && currTotal > 0 ? "translucentPrimary" : "translucent"
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "chevron",
      rotate: itemDelta >= 0 ? 0 : 180,
      s: {
        mt: -0.5
      }
    }), Math.abs(itemDelta).toFixed(0), "%")));
  }))));
};
export default ContributionsCard;